import { RegistEBaseDataService } from './api-services/regist-ebase-data.service';
import { MakeCandidateGoodsFileService } from './api-services/make-candidate-goods-file.service';
import { GoodsLockService } from './../../../commons/kymw00/api-services/goods-lock.service';
import { DeleteGoodsService } from './api-services/delete-goods.service';
import { RegistGoodsDetailCopyService } from './api-services/regist-goods-detail-copy.service';
import { OutputGoodsMasterProofService } from './api-services/output-master-proof-list.service';
import { DeleteNutrientCompositionService } from './api-services/delete-nutrient-composition.service';
import { RegistGoodsService } from './api-services/regist-goods.service';
import { GetConsumeTaxInfoService } from './api-services/get-consume-tax-info.service';
import { GetPurchasePriceService } from './api-services/get-purchase-price.service';
import { GetJANCodeService } from './api-services/get-jan-code.service';
import { DeleteGoodsDetailService } from './api-services/delete-goods-detail.service';
import { GetSupplierService } from './api-services/get-supplier.service';
import { GetGoodsDetailService } from './api-services/get-goods-detail.service';
import { GetGoodsBaseService } from './api-services/get-goods-base.service';
import { GetInitDataService } from './api-services/get-init-data.service';
import { KYMW1600Module } from './../../kymw16/kymw1600/kymw1600.module';
import { KYMW0C00Module } from './../../../commons/kymw0c/kymw0c00/kymw0c00.module';
import { KYMW0800Module } from './../../../commons/kymw08/kymw0800/kymw0800.module';
import { KYMW0600Module } from './../../../commons/kymw06/kymw0600/kymw0600.module';
import { KYMW0500Module } from './../../../commons/kymw05/kymw0500/kymw0500.module';
import { KYMW0700Module } from './../../../commons/kymw07/kymw0700/kymw0700.module';
import { KYMW0300Module } from './../../../commons/kymw03/kymw0300/kymw0300.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1100Component } from './kymw1100.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { KYMW1102Module } from '../kymw1102/kymw1102.module';
import { KYMW1103Module } from '../kymw1103/kymw1103.module';
import { KYMW1104Module } from '../kymw1104/kymw1104.module';
import { KYMW1105Module } from '../kymw1105/kymw1105.module';
import { KYMW1107Module } from '../kymw1107/kymw1107.module';
import { Kymw1108Module } from '../kymw1108/kymw1108.module';
import { FormsModule } from '@angular/forms';
import { RegistGoodsBaseCopyService } from './api-services/regist-goods-base-copy.service';
import { WjCoreModule } from '@grapecity/wijmo.angular2.core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GetCandidateGoodsListService } from './api-services/get-candidate-goods-list.service';
import { GetTagListService } from './api-services/get-tag-list.service';
import { GetPublishMediumInfoService } from './api-services/get-publish-medium-info.service';
import { GetOldGoodsTagListService } from './api-services/get-old-goods-tag-list.service';
import { UpdateCoopGoodsUrlDataService } from './api-services/update-coop-goods-url-data.service';
import { GetCoopGoodsUrlDataService } from './api-services/get-coop-goods-url-data.service';

/**
 * 商品マスタ画面 モジュール設定クラス
 *
 * @export KYMW1100Module
 * @class KYMW1100Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjCoreModule,
    WjGridModule,
    KYMW1102Module,
    KYMW1103Module,
    KYMW1104Module,
    KYMW1105Module,
    KYMW1107Module,
    Kymw1108Module,
    KYMW0300Module,
    KYMW0500Module,
    KYMW0600Module,
    KYMW0700Module,
    KYMW0800Module,
    KYMW0C00Module,
    KYMW1600Module,
    FontAwesomeModule
  ],
  declarations: [
    KYMW1100Component,
  ],
  providers: [
    GetInitDataService,
    GetGoodsBaseService,
    GetGoodsDetailService,
    GetSupplierService,
    DeleteGoodsService,
    DeleteGoodsDetailService,
    GetJANCodeService,
    RegistGoodsBaseCopyService,
    RegistGoodsDetailCopyService,
    GetPurchasePriceService,
    GetConsumeTaxInfoService,
    RegistGoodsService,
    OutputGoodsMasterProofService,
    DeleteNutrientCompositionService,
    GoodsLockService,
    MakeCandidateGoodsFileService,
    RegistEBaseDataService,
    GetCandidateGoodsListService,
    GetTagListService,
    GetPublishMediumInfoService,
    GetOldGoodsTagListService,
    UpdateCoopGoodsUrlDataService,
    GetCoopGoodsUrlDataService
  ],

})
export class KYMW1100Module { }
